import Vue from 'vue'
import Auth from '@/api/services/auth'
import i18n from '@/localization'
const getDefaultState = () => ({
  hideDock: false,
  token: Vue.ls.get('token', undefined, String),
  user_id: Vue.ls.get('user_id', undefined, Number),
  email: Vue.ls.get('email', undefined, String),
  lang: Vue.ls.get('lang', 'ru', String),
  appStatus: '',
  error: ''
})

export default {
  state: getDefaultState(),
  getters: {
    lang: state => state.lang,
    hideDock: state => state.hideDock,
    getToken: state => state.token,
    getUserId: state => state.user_id,
    getEmail: state => state.email,
    isAuthenticated: state => !!state.token && !!state.user_id && !!state.email,
    appStatus: state => state.appStatus,
    appError: state => state.error,
    nowDate () {
      return new Date()
    },
    dateDifference () {
      return (date1, date2) => Math.floor((Date.UTC(
        date2.getFullYear(),
        date2.getMonth(),
        date2.getDate()
      ) - Date.UTC(
        date1.getFullYear(),
        date1.getMonth(),
        date1.getDate()
      )) / 864e5)
    }
  },
  mutations: {
    dockVisibility (state, payload) {
      state.hideDock = payload
    },
    setLang (state, lang) {
      state.lang = lang
      Vue.ls.set('lang', lang)
      i18n.locale = lang
      Vue.moment.locale(lang)
    },
    authSuccess (state, data) {
      state.appStatus = 'success'
      state.token = data.token
      state.user_id = data.id_user
      state.email = data.email_user
    },
    authLogout (state) {
      state.appStatus = 'guest'
      state.token = undefined
      state.user_id = -1
      state.email = 'admin@admin.com'
      state.error = ''
    },
    authError (state, error) {
      state.appStatus = 'error'
      state.error = error.text
    },
    resetAppState (state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    setLang ({commit}, lang) {
      commit('setLang', lang)
    },
    authRequest ({commit, dispatch}, user) {
      return new Promise((resolve, reject) => {
        Auth.login(user)
          .then(response => {
            commit('authSuccess', response.data)
            resolve(response)
          }).catch(error => {
            commit('authError', error)
            reject(error)
          })
      })
    },
    authLogout ({commit}, leaveServerToken) {
      return new Promise(resolve => {
        Auth.logout(leaveServerToken).then(() => {
          commit('authLogout')
          commit('resetObjectsState')
          commit('resetAppState')
          commit('resetMapState')
          commit('resetFormsState')
          commit('resetReportsState')
          commit('resetEventsState')
          resolve()
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/appstate.js